/**
 * ExchangeRate Feature
 * Exporta servicio y tipos de Exchange Rate
 */

export { ExchangeRateService } from './services/exchange-rate.service';
export * from './models';
